import React, { useEffect } from 'react';
import { __ } from 'first-intl';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { A, useProgress } from '@hugendubel/react-basic';
import { WsBonusShopHistoryTransaction } from '../../../ws/result/WsBonusShopHistory';
import { RoutingUrl } from '../../appRoutes';
import { BonusPointTransactionTable } from './BonusPointTransactionTable';
import { Store } from '../../../store';
import { BonusPointHistoryService } from '../../../services/bonus-point-history-service';
import { BonusPointsDetails } from './BonusPointsDetails';

type BonusPointHistoryPageStoreProps = { transactions: WsBonusShopHistoryTransaction[] };
type BonusPointHistoryPageOwnProps = Record<string, unknown>;
export type BonusPointHistoryPageProps = BonusPointHistoryPageStoreProps & BonusPointHistoryPageOwnProps;

export const UnconnectedBonusPointHistoryPage: React.FC<BonusPointHistoryPageProps> = ({ transactions }) => {
    const [loading, withProgress] = useProgress();

    useEffect(() => {
        withProgress(BonusPointHistoryService.load);
    }, [withProgress]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <h1>
                        {__(process.env.IS_HUDU ? 'page.PointHistory.heading.hudu' : 'page.PointHistory.heading.eBook')}
                    </h1>
                </div>
                <div className="col-sm-4">
                    <BonusPointsDetails />
                </div>
            </div>
            <BonusPointTransactionTable transactions={transactions} loading={loading} />
            <div className="row buttons">
                <div className="col-xs-12">
                    <A className="btn btn-default" trackId={TRACK_ID('2019-07-31 02:28:16')} href={RoutingUrl.home()}>
                        {__('page.PointHistory.backToStore')}
                    </A>
                </div>
            </div>
        </div>
    );
};

export const BonusPointHistoryPage = Store.wire<BonusPointHistoryPageStoreProps, BonusPointHistoryPageOwnProps>(
    UnconnectedBonusPointHistoryPage,
    ({ transactions }) => ({ transactions })
);
